<template lang="pug">
  div
    el-button.btn(
        id='botao-filtro-avancado'
        @click="voltar"
      )
        div.btn-container
          div.icon-container
            font-awesome-icon(icon="chevron-left", size="sm" color="white")
          h3.text-btn Editar cadastro gleba {{municipiosNome}}
    el-card.card-container(shadow="hover")
      div.container-title
        p.title-divider Dados da gleba
        div.information-date
          div.information-date
            p.text-date Data Cadastro:
            p.text-date-value {{dataCadastro}}
          div.information-date
            p.text-date Última atualização:
            p.text-date-value {{dataAtualizacao}}
      el-row
        p.instructions {{'Insira os dados e faça o upload do shapefile da área'}}
      validation-observer(ref='validation' tag='div')
        form-gleba(:gleba="gleba" :localizacoes = "localizacoes")
    div.btn-cadastro-container
      el-button(
        @click="voltar",
        name="cancelar"
        class="cancelarButton"
      ).btn-cadastro
        span
          i.fas.fa-times
          b &nbsp Cancelar

      el-button(
          type="success",
          @click="salvar",
          name="salvar"
        ).btn-cadastro
          span
            i.fas.fa-save
            b &nbsp Salvar
</template>
<script>
import { mapActions } from 'vuex'
import AppLabel from '@/components/AppLabel'
import AppDivider from '@/components/AppDivider'
import FormGleba from '../components/FormGleba.vue'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import moment from 'moment'

export default {
  components: {
    AppLabel,
    AppDivider,
    FormGleba
  },

  mixins: [
    AppNotificacao
  ],

  data () {
    return {
      gleba: {
        idMunicipiosGleba: [],
        nome: '',
        areaTotal: null,
        areaRemanescente: null,
        nomeCartorio: '',
        idMunicipioCartorio: null,
        matricula: '',
        dataMatricula: null,
        dataCadastro: null,
        folha: '',
        livro: '',
        latitude: '',
        longitude: ''
      },
      localizacoes: [],
      municipiosMapa: [],
      municipiosNome: ''
    }
  },
  async created () {
    this.gleba = await this.buscarGleba(this.$route.params.id)
    if (this.gleba.localizacao) {
      const geometry = JSON.parse(this.gleba.localizacao)
      this.localizacoes.push({ geometry })
    }
  },
  computed: {
    dataCadastro () {
      return this.gleba.dataCadastro ? moment(this.gleba.dataCadastro).format('DD/MM/YYYY') : ''
    },
    dataAtualizacao () {
      return this.gleba.dataAtualizacao ? moment(this.gleba.dataAtualizacao).format('DD/MM/YYYY') : ''
    }
  },
  methods: {
    ...mapActions({
      editarGleba: 'gleba/editarGleba',
      buscarGleba: 'gleba/buscarGleba'
    }),
    voltar () {
      this.$router.push({
        name: 'bancoDados/gleba',
        params: {}
      })
    },
    async salvar () {
      const valido = await this.$refs.validation.validate()
      if (!valido) {
        this.showNotificacao(
          this.$messages.TIPO_WARNING,
          this.$messages.TITULO_WARNING,
          this.$messages.ERROS_ANALISE
        )
        return
      }
      if (this.localizacoes.length) {
        this.gleba.localizacao = this.localizacoes[0].geometry
      } else {
        this.gleba.localizacao = null
      }
      await this.editarGleba({gleba: this.gleba, id: this.$route.params.id})
      this.voltar()
      this.showNotificacao(
        this.$messages.TIPO_SUCCESS,
        this.$messages.TIPO_SUCCESS,
        this.$messages.ATUALIZAR_GLEBA
      )
    }
  },
  watch: {
    'municipios' (newVal) {
      if (newVal.length) {
        let nomes = []
        this.gleba.idMunicipiosGleba.forEach(id => {
          nomes.push((newVal.find(municipio => municipio.id === id)).nome)
        })
        this.municipiosNome = nomes
      }
    }
  }
}

</script>
<style lang="scss" scoped>
@import "@/assets/styles/element-variables.scss";
.full-width {
  width: 100% !important;
}
.card-container {
  margin: 0px;
  margin-top: 30px;
  border-radius: 10px;
}
.instructions {
  padding-bottom: 20px;
  font-weight: bold;
  color: #606266 !important;
}
.btn-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 10px;
}
.btn {
  padding : 0px !important;
  border: 0px;
}
.text-btn {
  margin: 3px !important;
}
.icon-container {
  background-color: #009f61;
  padding-top : 5px;
  padding-bottom : 5px;
  padding-left: 10px;
  padding-right: 10px;
  border-radius: 5px;
}
.btn-cadastro-container {
  display: flex;
  justify-content: space-between;
  margin: 20px;
}
.btn-cadastro {
  width: 200px;
}
.container-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 2px solid $--divider-color;
  margin-bottom: 20px;
}
.information-date {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
}
.text-date {
  font-weight: bold;
  color: #606266 !important;
  font-size: 12px;
}
.text-date-value {
  color: #606266 !important;
  font-size: 12px;
}
.title-divider {
  font-weight: bold;
  color: #606266 !important;
  margin-bottom: 5px !important;
}
</style>



// WEBPACK FOOTER //
// src/screens/bancoDados/gleba/EditarGleba.vue